var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIrIconSensia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9939_55900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 75,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79501 8.67639C6.58161 8.67639 4.78694 10.3862 4.78694 12.4952L2 71.1815C2 73.2906 3.79467 75 6.00807 75H72.9915C75.2053 75 77 73.2906 77 71.1815L73.4154 3.81885C73.4154 1.70977 71.6208 -3.87169e-06 69.407 -3.87169e-06L8.79501 8.67639Z",
    fill: "#F7F5F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9939_55900)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79501 11.6764C7.58161 11.6764 5.78694 13.3862 5.78694 15.4952L3 74.1815C3 76.2906 4.79467 78 7.00807 78H73.9915C76.2053 78 78 76.2906 78 74.1815L74.4154 6.81885C74.4154 4.70977 72.6208 3 70.407 3L9.79501 11.6764Z",
    fill: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2258 33.3917L42.6526 12.2371C41.8784 11.4494 40.7717 11 39.6651 11C38.5585 11 37.4541 11.4494 36.6777 12.2371L15.8857 33.167C15.444 33.6164 15.2231 34.1793 15.1115 34.7422C15 34.9669 15 35.1939 15 35.4186V59.7237C15 62.0866 16.8808 64 19.2034 64H59.7966C62.1192 64 64 62.0866 64 59.7237V35.4186V35.3051C64 34.631 63.6676 33.8433 63.2258 33.3917ZM60.901 42.7319H47.3437C46.4077 41.041 44.5771 39.8084 41.5831 38.7315C37.9636 37.4032 36.0041 36.3219 36.0041 34.4062C36.0041 32.8755 37.1435 31.2424 40.3387 31.2424C42.9063 31.2424 44.7543 31.9099 45.955 32.4505L46.8516 29.0175C45.6291 28.5013 43.9473 27.9806 41.5 27.9072C41.1195 27.8961 40.8177 27.5779 40.8177 27.1908V24.1248H38.0861V27.4889C38.0861 27.8338 37.8455 28.1297 37.5109 28.192C33.4037 28.973 30.9521 31.5672 30.9521 35.1338C30.9521 38.4601 33.08 40.6071 38.0708 42.3136C38.471 42.4494 38.8516 42.5873 39.2124 42.7297H47.1491C47.7177 43.7153 47.978 44.8545 47.978 46.2139C47.978 49.9385 45.3404 52.6974 41.0954 53.4116C40.7564 53.4672 40.5071 53.7676 40.5071 54.1169V57.8258H37.7362V54.4617C37.7362 54.079 37.4409 53.7631 37.0648 53.7475C34.3966 53.6252 32.0696 52.9065 30.6765 52.239L31.5841 48.6346C33.0603 49.3466 35.3939 50.1965 38.1298 50.1965C41.0451 50.1965 42.9281 48.8705 42.9281 46.8169C42.926 44.7966 41.3272 43.6731 38.8494 42.7297H17.9875V35.5276L18.099 35.4141L38.7816 14.4842C39.2233 14.0348 39.9975 14.0348 40.4415 14.4842L60.9032 35.5254V42.7319H60.901Z",
    fill: "#86AA63"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIrIconSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/IRIconSensia.3b9e5345bdf387f3fa716acee47bdb41.svg";